// extracted by mini-css-extract-plugin
export default {"icons":"IconsSection_icons__mSpcB","text":"IconsSection_text__eTEia"};